// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-preview {
  margin: 0 60px;
  position: relative;
}
.content-preview > img {
  border-radius: 10px 10px 0 0;
  height: 280px;
  width: 100%;
  object-fit: cover;
}
.content-preview .content {
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1490196078);
  border-top: none;
  padding: 10px 20px;
  margin-top: -5px;
}
.content-preview .content .title {
  font-weight: 700;
  font-size: 20px;
  margin: 0;
  color: var(--secondary-color-1);
}
.content-preview .content .desc {
  font-size: 16px;
  font-weight: 400;
  color: var(--secondary-color-3);
  line-height: 25px;
}
.content-preview .icon {
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: white;
  border-radius: 5px;
  height: 30px;
  width: 30px;
  padding: 4px;
}`, "",{"version":3,"sources":["webpack://./src/routes/Listing/modules/ListingDetail/modules/Tabs/modules/ListingWaggle/modules/FeedPost/modules/PreviewBlock/previewBlock.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;AACJ;AAAI;EACI,4BAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AAER;AAAI;EACI,4BAAA;EACA,mDAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAER;AADQ;EACI,gBAAA;EACA,eAAA;EACA,SAAA;EACA,+BAAA;AAGZ;AADQ;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;AAGZ;AAAI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAER","sourcesContent":[".content-preview {\n    margin: 0 60px;\n    position: relative;\n    > img { \n        border-radius: 10px 10px 0 0;\n        height: 280px;\n        width: 100%;\n        object-fit: cover;\n    }\n    .content {\n        border-radius: 0 0 10px 10px;\n        box-shadow: 0px 0px 2px #00000026;\n        border-top: none;\n        padding: 10px 20px;\n        margin-top: -5px;\n        .title {\n            font-weight: 700;\n            font-size: 20px;\n            margin: 0;\n            color: var(--secondary-color-1);\n        }\n        .desc {\n            font-size: 16px;\n            font-weight: 400;\n            color: var(--secondary-color-3);\n            line-height: 25px;\n        }\n    }\n    .icon {\n        position: absolute;\n        right: 10px;\n        top: 10px;\n        background-color: white;\n        border-radius: 5px;\n        height: 30px;\n        width: 30px;\n        padding: 4px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
